import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AuditHelperFunctions } from 'src/app/helpers/audit-helper-functions';
import { AuditStructualDataDetailsViewModel } from 'src/app/models/audit-structural-data-details-view-model';
import { AuditService } from 'src/app/services/audit.service';

@Component({
  selector: 'app-audit-structural-data-details',
  templateUrl: './audit-structural-data-details.component.html',
  styleUrls: ['./audit-structural-data-details.component.scss']
})
export class AuditStructuralDataDetailsComponent implements OnInit {
  @Input() merchantNumber: string;

  public dtOptions: DataTables.Settings;
  public dtTrigger: Subject<boolean> = new Subject();
  public auditStructualDataDetailsViewModel: AuditStructualDataDetailsViewModel[] = [];

  private auditHelperFunctions: AuditHelperFunctions;

  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;
  dtInstance: Promise<DataTables.Api>;

  constructor(private _auditService: AuditService) {
    this.auditHelperFunctions = new AuditHelperFunctions();
  }

  async ngOnInit(): Promise<void> {
    this.dtOptions = {
      order: [''],
      pageLength: 10,
      pagingType: 'full_numbers'
    };
    this.auditStructualDataDetailsViewModel = await this._auditService.GetStructuralDataDetails(this.merchantNumber);
    this.dtTrigger.next();
  }

  public DownloadCsv(): void {
    this.auditHelperFunctions.DownloadCsv(this.auditStructualDataDetailsViewModel, 'MerchantAuditTrail_StructuralData_');
  }

  public print(): void {
    this.auditHelperFunctions.print();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
}
